import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  Title,
  Description,
} from 'components/landing/components';

import './Perk.css';


const dumbPerk = dumbBem('l-careers-perk');
const PerkWrp = tx(dumbPerk)('div');

const Content = tx([{ element: 'content' }, dumbPerk])('div');
const Icon = tx([{ element: 'icon' }, dumbPerk])('div');


export class Perk extends Component {
  render() {
    const { icon, title, description } = this.props;

    return (
      <PerkWrp>
        <Icon>
          <img src={icon} alt="" data-testid="img" />
        </Icon>

        <Content>
          <Title modifier="3">{title}</Title>
          <Description>{description}</Description>
        </Content>
      </PerkWrp>
    );
  }
}

Perk.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default Perk;



// WEBPACK FOOTER //
// ./src/components/landing/pages/careers/Perk/Perk.js